import type { ProjectMissionSnapshot } from '../contracts/types'
import type { CommandDeckMissionReadModelReaders } from './commandDeckMissionReadModel.types'

/**
 * Read-only active project snapshot. Returns null on any guard failure — never substitutes ORBIS.
 */
export function loadActiveProjectMissionSnapshot(
  projectId: string | null | undefined,
  readers: Pick<CommandDeckMissionReadModelReaders, 'loadProjectSnapshot'>
): ProjectMissionSnapshot | null {
  const id = projectId?.trim()
  if (!id) return null

  const loaded = readers.loadProjectSnapshot(id)
  if (!loaded) return null
  if (loaded.projectId !== id) return null

  return loaded
}
